(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tronstation-sdk", [], factory);
	else if(typeof exports === 'object')
		exports["tronstation-sdk"] = factory();
	else
		root["tronstation-sdk"] = factory();
})(self, () => {
return 